
const state = () => ({
  indexes: [],
})

const getters = {}

const mutations = {
  indexes (state, v) {
    state.indexes = v
  },
}

const actions = {
  reset ({ commit }) {},
  paid ({ dispatch }) {
    dispatch('orders/payment/reset', null, { root: true })
  },
  // from XEF's GSMoveMenuSupplementsToStandardContents.m
  moveMenuSupplementsToStandardContents ({ commit, rootState }) {
    rootState.orders.current.orderContents.forEach((content, orderContentIndex) => {
      if (content.quantity <= 1 || ! content.subContents.length) {
        return
      }
      content.subContents.forEach((subContent, subContentIndex) => {
        if (subContent.priceWithExtrasIndividual.lessThanOrEqualTo(0)) {
          return
        }
        const newContent = {
          quantity: 1,
          alreadyPrintedQuantity: 1,
          itemName: `(S) ${subContent.itemName}`,
          item_id: subContent.item_id,
          itemPrice: subContent.itemPrice,
          modifiers: subContent.modifiers,
          dishOrder: content.dishOrder,
        }
        commit('orders/addContent', newContent, { root: true })
        commit('orders/removeSubContent', { orderContentIndex, subContentIndex }, { root: true })
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
